<div class="container pt-3">
  <div class="madar--v2" [class.page-header-container--fixed]="showBreadcrumb">
    <div class="page-header page-header--breadcrumb bg-white px-6" *ngIf="showBreadcrumb" #breadcrumbBar>
      <div class="page-header__content flex align-center justify-space-between wrap">
        <div class="page-header__start flex align-center wrap">
          <app-breadcrumb>
            <ng-content select="[breadcrumbSuffix]"></ng-content>
          </app-breadcrumb>
        </div>
        <div class="page-header__end flex align-center">
          <ng-container *ngTemplateOutlet="trailingTemplate"></ng-container>
        </div>
      </div>
    </div>

    <div class="weight-semibold pb-3" *ngIf="!showBreadcrumb">
      <app-row justify="space-between" class="align-center" gutter="xs">
        <app-col cols="auto" md="auto">
          <div class="flex align-center">
            <ng-content select="[icon]"></ng-content>
            <p class="m-0 text-900 weight-medium h6">
              <ng-content select="[title]"></ng-content>
            </p>
          </div>
        </app-col>
        <app-col cols="12" md="auto">
          <div class="action">
            <ng-container *ngTemplateOutlet="trailingTemplate"></ng-container>
          </div>
        </app-col>
      </app-row>
    </div>
  </div>

  <div class="page-content">
    <div class="content">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>

<!-- Define a template for the trailing content -->
<ng-template #trailingTemplate>
  <ng-content select="[trailing]"></ng-content>
</ng-template>
